import { Badge } from '@liveauctioneers/hammer-ui-core/badge';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';
import styled from 'styled-components';

import { ImageRow } from '@/components/ItemCard/ImageRow';
import ItemPriceGatewayContainer from '@/components/ItemPriceGateway/ItemPriceGatewayContainer';

import { ItemCardComponent, ItemCardInfo } from '../../../../types/types';
import ItemCardShortDate from '../../../components/ItemCardShortDate/ItemCardShortDate';
import ItemCardTitle from '../../../components/ItemCardTitle/ItemCardTitle';

const SoldItemPageSimilarItemCard: ItemCardComponent = ({ className, dimension, itemId }) => {
    const [hover, setHover] = React.useState(false);

    return (
        <SoldItemPageItemCardContainer
            $dimension={dimension}
            className={className}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <StyledImageContainer>
                <Badge
                    className="absolute left-xs top-xs"
                    color="neutral"
                    emphasis="bold"
                    size="sm"
                >
                    <FormattedMessage id="similarSoldItemCarousel.badge" />
                </Badge>
                <PlacedItemCardImage
                    dimension={dimension}
                    itemId={itemId}
                />
            </StyledImageContainer>
            <PlacedItemCardShortDate
                itemId={itemId}
                showOnlyYear
            />
            <PlacedItemCardTitle
                isHovered={hover}
                itemId={itemId}
            />
            <PlacedItemPriceGatewayContainer
                hideIcon
                itemId={itemId}
                onMouseEnter={() => setHover(false)}
                onMouseLeave={() => setHover(true)}
            />
        </SoldItemPageItemCardContainer>
    );
};

const info: ItemCardInfo = {
    dimensions: { desktop: 184, mobile: 164 },
    ItemCardComponent: SoldItemPageSimilarItemCard,
};

export default info;

const StyledImageContainer = styled.section`
    position: relative;
`;

const PlacedItemCardImage = styled(ImageRow)`
    grid-area: img;
`;

const PlacedItemCardTitle = styled(ItemCardTitle)`
    grid-area: title;
`;

const PlacedItemCardShortDate = styled(ItemCardShortDate)`
    grid-row: date;
`;

// This should be a ActionText but one that actually matches the style (it don't exist)
const PlacedItemPriceGatewayContainer = styled(ItemPriceGatewayContainer)`
    grid-area: soldprice;
    font-size: 16px;
    button {
        text-decoration: none;
        color: ${({ theme }) => theme.colors.blue200};
    }

    &:hover button {
        text-decoration: underline;
    }
`;

const SoldItemPageItemCardContainer = styled.div<{ $dimension: number }>`
    position: relative;
    display: grid;
    grid-template-columns: ${({ $dimension }) => ($dimension ? `${$dimension}px` : '1fr')};
    grid-template-rows: min-content 8px 20px 4px min-content 4px min-content;
    grid-template-areas:
        'img'
        '.'
        'date'
        '.'
        'title'
        '.'
        'soldprice';
`;
